import {
  FundingTxModel,
  MegaShareTxModel,
  PlaySpinTxModel,
  SecretCodeCampaign,
  SecretCodeCampaignParticipant,
  WalletStatus,
} from "kz-ui-sdk";

export enum WS_EVENT {
  DEPOSIT_SUCCESS = "WS_DEPOSIT_SUCCESS",
  BALANCE_CHANGED = "WS_BALANCE_CHANGED",
  TOKEN_CHANGE_EVENT = "WS_TOKEN_CHANGE_EVENT",
  BLACKLIST_UPDATE = "WS_BLACKLIST_UPDATE",
  REFERRAL_TOKEN_SETTINGS_CHANGE = "WS_REFERRAL_TOKEN_SETTINGS_CHANGE",
  SKINNER_BOX_AMOUNT_CHANGED = "WS_SKINNER_BOX_AMOUNT_CHANGED",
  CS_COMPENSATION_UPDATED = "WS_CS_COMPENSATION_UPDATED",
  PLAY_SPIN_UPDATED = "WS_PLAY_SPIN_UPDATED",
  MEGA_SHARE_UPDATED = "WS_MEGA_SHARE_UPDATED",
  WITHDRAWAL_CANCELLED = "WS_WITHDRAWAL_CANCELLED",
  CASHBACK_REWARD_UPDATED = "WS_CASHBACK_REWARD_UPDATED",
  REFERRAL_BALLS_REWARD_UPDATED = "WS_REFERRAL_BALLS_REWARD_UPDATED",
  REFERRAL_COMMISSION_REWARD_UPDATED = "WS_REFERRAL_COMMISSION_REWARD_UPDATED",
  SECRET_CODE_UPDATED = "WS_SECRET_CODE_UPDATED",
}

export type WSBalanceChangedEventDetail = {
  balance: string;
};

export type WSBalanceChangedEvent = CustomEvent<WSBalanceChangedEventDetail>;

export type WSDepositSuccessEventDetail = {
  fundingTx?: FundingTxModel;
};

export type WSDepositSuccessEvent = CustomEvent<WSDepositSuccessEventDetail>;

export type WSTokenChangeEventDetail = {
  tokenCount: number;
};

export type WSTokenChangeEvent = CustomEvent<WSTokenChangeEventDetail>;

export type WSBlacklistUpdateEventDetail = {
  isBlacklisted: boolean;
  timestamp: string;
};

export type WSBlacklistUpdateEvent = CustomEvent<WSBlacklistUpdateEventDetail>;

export type WSReferralTokenSettingsChangeEventDetail = {};

export type WSReferralTokenSettingsChangeEvent = CustomEvent<WSReferralTokenSettingsChangeEventDetail>;

export type WSSkinnerBoxAmountChangedEventDetail = {
  availableAmount: number;
};

export type WSSkinnerBoxAmountChangedEvent = CustomEvent<WSSkinnerBoxAmountChangedEventDetail>;

export type WSCsCompensationUpdatedEventDetail = {
  compensationTxId: string;
};

export type WSCsCompensationUpdatedEvent = CustomEvent<WSCsCompensationUpdatedEventDetail>;

export type WSPlaySpinUpdatedEventDetail = {
  lastPlaySpinTx: PlaySpinTxModel;
};

export type WSPlaySpinUpdatedEvent = CustomEvent<WSPlaySpinUpdatedEventDetail>;

export type WSMegaShareUpdatedEventDetail = {
  megaShareTx: MegaShareTxModel;
  sharedMegaShareTx: MegaShareTxModel;
};

export type WSMegaShareUpdatedEvent = CustomEvent<WSMegaShareUpdatedEventDetail>;

export type WSWithdrawalCancelledEventDetail = {
  fundingTx?: FundingTxModel;
};

export type WSWithdrawalCancelledEvent = CustomEvent<WSWithdrawalCancelledEventDetail>;
export type WSCashbackRewardUpdatedEventDetail = {
  instant: WalletStatus;
  daily: WalletStatus;
  weekly: WalletStatus;
  monthly: WalletStatus;
};

export type WSCashbackRewardUpdatedEvent = CustomEvent<WSCashbackRewardUpdatedEventDetail>;

export type WSReferralCommissionRewardUpdatedEventDetail = {};

export type WSReferralCommissionRewardUpdatedEvent = CustomEvent<WSReferralCommissionRewardUpdatedEventDetail>;

export type WSSecretCodeUpdatedEventDetail = {
  campaign?: SecretCodeCampaign | null;
  participant?: SecretCodeCampaignParticipant | null;
};

export type WSSecretCodeUpdatedEvent = CustomEvent<WSSecretCodeUpdatedEventDetail>;
